/*eslint-disable*/
import { usePost, useGet } from "./useRequest";

export const loadNotes = (note, noteTypeId = null) => {
  const path = "/applicantagreementdocumentnotes/" + note.entityId + "/" + note.entityType + (noteTypeId ? "?noteTypeId=" + noteTypeId : "");
  const response = useGet(path);
  return response;
};

export const addNote = (note, candidateId, jobId) => {
  const path = `/applicantagreementdocumentnotes/${note.entityId}?candidateId=${candidateId}&jobId=${jobId}`;
  const response = usePost(path, note);
  return response;
};

export const loadNoteTypes = () => {
  const path = "/notetypes";
  const response = useGet(path);
  return response;
};

export function loadEmailByNote(id) {
  const path = "/applicantagreementdocumentnotes/" + id + "/email";
  const response = useGet(path);
  return response;
}